import React, { useRef, useState } from "react";
import BaseModal from "../../modals/base-modal";
import FormField from "../../forms/form-field";
import InlineModal from "../../info-modal/infoModal";
import { instanceMob } from "../../../utils/utils";
import { getBackendError } from "../../../utils/error-helpers";

const TYPE_MAPPING = {
    CATEGORY: {
        text: "Categoría",
        text_lower: "categoría",
        endpoint: "admin/accounting/category/create",
    },
    BRAND: {
        text: "Marca",
        text_lower: "marca",
        endpoint: "admin/accounting/brand/create",
    },
};

const CreateGenericItemModal = ({ show, onClose, itemType }) => {
    const formRef = useRef(null);
    const [infoModal, setInfoModal] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const itemDetails = TYPE_MAPPING[itemType];

    const getEndpoint = () => {
        if (!itemDetails) {
            throw new Error(`Tipo de ítem desconocido: ${itemType}`);
        }
        return itemDetails.endpoint;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const formData = new FormData(formRef.current);
        const payload = Object.fromEntries(formData.entries());
        const endpoint = getEndpoint();

        if (!itemDetails) return;

        if (!payload.name) {
            setInfoModal({
                iconType: "error",
                title: "Campo requerido",
                description: `Por favor, ingresa el nombre de la ${itemDetails.text_lower}.`,
                secondaryAction: { label: "Cerrar", onClick: () => setInfoModal(null) },
            });
            return;
        }

        setIsLoading(true);

        instanceMob
            .post(endpoint, payload)
            .then((res) => {
                const newItem = res.data;

                setInfoModal({
                    iconType: "success",
                    title: `${itemDetails.text} creada`,
                    description: `La ${itemDetails.text_lower} fue registrada con éxito.`,
                    primaryAction: {
                        label: "Aceptar",
                        onClick: () => {
                            setInfoModal(null);
                            onClose(newItem);
                        },
                    },
                });
            })
            .catch((err) => {
                const errorMessage = getBackendError(err);
                setInfoModal({
                    iconType: "error",
                    title: "Error",
                    description: errorMessage,
                    secondaryAction: {
                        label: "Cerrar",
                        onClick: () => setInfoModal(null),
                    },
                });
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    if (!itemDetails) {
        return null;
    }

    return (
        <>
            <BaseModal
                show={show}
                onClose={() => onClose(null)}
                title={`Crea una ${itemDetails.text_lower}`}
                onSave={() => formRef.current.requestSubmit()}
                isSaving={isLoading}
            >
                <form
                    className="d-flex flex-column gap-2"
                    ref={formRef}
                    onSubmit={handleSubmit}
                >
                    <FormField
                        label={`Nombre de la ${itemDetails.text}`}
                        name="name"
                        type="text"
                        placeholder={`Escribe el nombre de la ${itemDetails.text_lower}`}
                        isLoading={isLoading}
                        required={true}
                    />
                </form>
            </BaseModal>

            {infoModal && (
                <InlineModal
                    icon={infoModal.icon}
                    iconType={infoModal.iconType}
                    title={infoModal.title}
                    description={infoModal.description}
                    primaryAction={infoModal.primaryAction}
                    secondaryAction={infoModal.secondaryAction}
                />
            )}
        </>
    );
};

export default CreateGenericItemModal;